<div class="modal-header bg-danger">
    <h4 class="modal-title text-white">{{title}}</h4>
    <button type="button" class="close text-white" aria-label="Close" (click)="close(false);">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body modal-body d-flex align-items-center justify-content-center" style="min-height:80px">
    {{message}}
</div>

<div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-danger text-white w-25 px-2 py-2 mr-3" (click)="close(true)">Yes</button>
    <button type="button" class="btn btn-danger text-white w-25 px-2 py-2" (click)="close(false)">No</button>
</div>  
